import { localized } from '@/i18n/localize'

export const shellStrings = localized({
  main: 'Main',
  portfolio: 'Portfolio',
  money: 'Money',
  renting: 'Renting',
  account: 'Account',
  dashboard: 'Dashboard',
  home: 'Home',
  properties: 'Properties',
  interests: 'Interests',
  leases: 'Leases',
  tenants: 'Tenants',
  maintenance: 'Maintenance',
  transactions: 'Transactions',
  subscription: 'Subscription',
  browse: 'Browse',
  leaseHistory: 'Lease history',
  myProfile: 'My tenant profile',
  myInterests: 'My interests',
  notifications: 'Notifications',
  settings: 'Settings',
  help: 'Help & support',
  kyc: 'KYC & banking',
  notificationSettings: 'Notification settings',
  collapse: 'Collapse sidebar',
  expand: 'Expand sidebar',
  signedInAs: (role: string) => `Signed in as ${role}`,
  landlord: 'landlord',
  tenant: 'tenant',
  search: 'Search or jump to…',
  searchShort: 'Search',
  pages: 'Pages',
  actions: 'Actions',
  addProperty: 'Add property',
  createLease: 'Create lease',
  recordPayment: 'Record payment',
  browseProperties: 'Browse properties',
  editTenantProfile: 'Edit my tenant profile',
  searchProperties: 'Properties',
  searchTenants: 'Tenants',
  searchLeases: 'Leases',
  noMatches: 'No matches',
  viewAll: 'View all',
  markAllRead: 'Mark all read',
  noNotifications: "You're all caught up",
  notificationsError: "Couldn't load notifications",
  accountMenu: 'Account menu',
  logout: 'Log out',
  logoutConfirmTitle: 'Log out?',
  logoutConfirmMessage: "You'll need to sign in again with a code.",
  cancel: 'Cancel',
  shortcuts: 'Keyboard shortcuts',
  shortcutPalette: 'Open the command menu',
  shortcutSearch: 'Search',
  shortcutHelp: 'Show keyboard shortcuts',
  shortcutClose: 'Close a dialog or menu',
})
